import { Modal, Button } from "react-bootstrap";
import { GamePlayedItem } from "../models/UserData";
import { SKILLS } from "./SkillTable";

export interface GameDetailsModalProps {
    show: boolean;
    game: GamePlayedItem | undefined;
    onHide: () => void;
    onGameDelete: () => void
}

export const GameDetailsModal = ({ show, game, onHide, onGameDelete }: GameDetailsModalProps): React.ReactElement => {
    return (
        <Modal centered size='lg' show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{game?.name ?? ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {Object.entries(game?.xp ?? {}).filter(([, xp]) => xp > 0).map(([skill, xp]) => <span key={skill} title={SKILLS[skill].name}><Button variant='outline-dark' disabled style={{ width: '7rem', margin: '0.5rem' }}>{SKILLS[skill].icon} {xp} xp</Button></span>)}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onGameDelete}>
                    Remove
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
